module.exports = __webpack_public_path__ + "static/img/home.fa8aa43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/home.png
// module id = +B9e
// module chunks = 26